/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Column_Lastused_Tooltip3Inputs */

const en_settings_reportingapikeys_column_lastused_tooltip3 = /** @type {(inputs: Settings_Reportingapikeys_Column_Lastused_Tooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most recent successful API authentication with this key. 'Never' means no use since usage tracking was introduced – earlier usage is not backfilled. Dates are shown as DD/MM/YYYY in UTC.`)
};

/**
* | output |
* | --- |
* | "Most recent successful API authentication with this key. 'Never' means no use since usage tracking was introduced – earlier usage is not backfilled. Dates ar..." |
*
* @param {Settings_Reportingapikeys_Column_Lastused_Tooltip3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_column_lastused_tooltip3 = /** @type {((inputs?: Settings_Reportingapikeys_Column_Lastused_Tooltip3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Column_Lastused_Tooltip3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_column_lastused_tooltip3(inputs)
});
export { settings_reportingapikeys_column_lastused_tooltip3 as "settings_reportingApiKeys_column_lastUsed_tooltip" }